<template>
    <div class="courseTabBar">
        <div class="courseTabBarList_item" :class="{courseTabBarList_item_active : index == courseTabBarListIndex}" v-for="(item, index) in courseTabBarList" :key="index" @click="selectCourseTabBarList(index)">{{item}}</div>
    </div>
</template>

<script>
export default {
    name: 'courseTabBar',
    data(){
        return {
            courseTabBarList: ['大纲流程','视频','PPT课件','课程说明书','学习手册'],
            courseTabBarListIndex: 0
        }
    },
    methods:{
        selectCourseTabBarList(index){
            this.courseTabBarListIndex = index;
            this.$root.center.$emit('courseInfoType',index);
        }
    }
}
</script>

<style>
    .courseTabBar{
        background:#ffffff;
        border:1px solid #5576ab;
        border-radius:4px;
        width:353px;
        height:36px;
        margin: auto;
        display: flex;
    }
    .courseTabBarList_item{
        flex: 1;
        font-family:PingFangSC-Regular;
        font-size:13px;
        color:#5576ab;
        line-height: 36px;
        letter-spacing:0;
        text-align:center;
        border-right: 1px solid #5576ab; 
    }
    .courseTabBarList_item:last-child{
        border-right: none;
    }
    .courseTabBarList_item_active{
        background:#5576ab;
        /* border-radius:4px 0 0 4px; */
        font-family:PingFangSC-Medium;
        color:#ffffff;
    }
</style>



// WEBPACK FOOTER //
// src/components/courseTabBar/courseTabBar.vue